import React from 'react';
import { getRandomAffordance } from '../../util';

class CommentAdd extends React.Component {

	constructor(props) {
		super(props);
		
		this.state = {
			placeholder: getRandomAffordance()
		}

    	this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
		this.props.setBody(e.target.value);
	}
	
	render() {
		
		const hasContent = this.props.body.trim().length > 0;

		let className = 'textarea';
		if(this.props.inline) className += ' textarea--inline';
		if(hasContent) className += ' hasContent';

		return (
			<textarea className={className} value={this.props.body} 
				placeholder={this.state.placeholder} onChange={this.handleChange}>
			</textarea>
		);
	}
}

export default CommentAdd


// WEBPACK FOOTER //
// ./src/components/comment/CommentAdd.js